module.exports = __webpack_public_path__ + "static/media/logo-higa-header.39ae8f49.png";